import onArticleCardCarouselSettingsReady$ from './components/articleCardCarouselHandler';

export default onArticleCardCarouselSettingsReady$;
